export const DATE_FORMAT = 'YYYY-MM-DD'

export const accommodationTypeMap = {
  apartment: 'Apartment',
  hotel: 'Hotel',
  villa: 'Villa',
}



// WEBPACK FOOTER //
// ./src/utils/constants.js